import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

// Path data from Phosphor Icons (Regular weight, arrow-clockwise). MIT licensed.
// https://github.com/phosphor-icons/core
export default function IconRefresh(props: SvgIconProps) {
  return (
    <SVGIcon
      width="16"
      height="16"
      viewBox="0 0 256 256"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16H211.4L184.81,71.64l-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,0,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60L224,85.8V56a8,8,0,1,1,16,0Z" />
    </SVGIcon>
  );
}
